export default __webpack_public_path__ + "static/media/222.c9d5acc6.png";